import React, { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from "react";
import './menu.css'
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { BorderMenuPage, emptyMenuPage, MenuContentPage } from "../types/types";
import { PageMenu } from "../pageMenu/pageMenu";
import RightBar from "./RightBarRestau/RightBarRestau";
import { LiaHandPointerSolid } from "react-icons/lia";
import { MdFullscreen } from "react-icons/md";
import { TfiClose } from "react-icons/tfi";
import MaskBackground from "../maskBackground/maskBackground";
interface MenuProps {
    styleMenu:number,
    dobbleMenu: [MenuContentPage,MenuContentPage][],
    dateUpdate:Date,
    interactmenu:boolean,
    setFullPlat?:Dispatch<SetStateAction<string>>,
    startPage?:[number,number],
}

export function useIsPinchZoomed(isMobile: boolean) {
  const isZoomedRef = useRef(false); 

  useEffect(() => {
    if (!isMobile) return;
    let raf = 0;

    const update = () => {
      raf = 0;
      const scale = vv?.scale ?? 1;
      isZoomedRef.current = scale > 1.01;
    };


    const onChange = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const vv = (window as any).visualViewport;
    if (vv) {
      vv.addEventListener("resize", onChange, { passive: true });
      vv.addEventListener("scroll", onChange, { passive: true });
      update();
      return () => {
        vv.removeEventListener("resize", onChange);
        vv.removeEventListener("scroll", onChange);
        if (raf) cancelAnimationFrame(raf);
      };
    }

    const onWindowChange = () => {
      const ratio = document.documentElement.clientWidth / window.innerWidth;
      isZoomedRef.current = ratio < 0.98;
    };
    window.addEventListener("resize", onWindowChange, { passive: true });
    window.addEventListener("orientationchange", onWindowChange);
    onWindowChange();
    return () => {
      window.removeEventListener("resize", onWindowChange);
      window.removeEventListener("orientationchange", onWindowChange);
    };
  }, [isMobile]);

  return { isZoomedRef };
}
function useIsMobile() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        function checkMobile() {
        setIsMobile(window.matchMedia('(max-width: 1050px)').matches);
        }
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    return isMobile;
}
const MenuRestau:React.FC<MenuProps> = ({styleMenu,dobbleMenu,dateUpdate,interactmenu,setFullPlat,startPage}) => {
    const [pageShow, setPageShow] = useState([0,1])
    const [currentZindex, setCurrentZIndex] = useState(dobbleMenu.length*2)
    const [maxIndex,setMaxIndex] = useState(dobbleMenu.length*2)
    const [borderPages,setBorderPages] = useState<BorderMenuPage | null>(null)

    const [fullScreen,setFullScreen] = useState(false)
    const [showAnimation,setShowAnimation]= useState(false)
    const [borderStyleVars, setBorderStyleVars] = useState<React.CSSProperties>({});

    const nudgeScroll = () => {
        requestAnimationFrame(() => {
            const y = window.scrollY || document.documentElement.scrollTop || 0;
            window.scrollTo(0, y + 10);
            requestAnimationFrame(() => window.scrollTo(0, y));
        });
    };
    const isMobile = useIsMobile();
    const lengthMenuPhone = React.useMemo(() => {
        if (!dobbleMenu || !dobbleMenu.length) return 0;
        if (dobbleMenu.length < 2) return 1;

        const last = dobbleMenu[dobbleMenu.length - 1];
        const backEmpty = last[1].elements.length === 0;
        const frontEmpty = last[0].elements.length === 0;

        const penalty = backEmpty ? (frontEmpty ? 3 : 2) : 1;
        return dobbleMenu.length * 2 - penalty;
    }, [dobbleMenu]);
    useEffect(() => { 
        if(dobbleMenu && dobbleMenu.length > 1 && 'borderpage' in dobbleMenu[0][1] && dobbleMenu[0][1].borderpage) {
            setBorderPages(dobbleMenu[0][1].borderpage as BorderMenuPage| null)
            const {color, colorline} = dobbleMenu[0][1].borderpage
            setBorderStyleVars(() => {
                const vars: React.CSSProperties = {};

                if (color) {
                (vars as any)['--qr-border-bg-strong'] = color;
                (vars as any)['--qr-border-bg-soft'] = color;
                }

                if (colorline) {
                (vars as any)['--qr-border-line'] = colorline;
                }

                return vars;
            });
        }
        
        if (typeof window === "undefined" || !window.matchMedia('(max-width: 1050px)').matches) return;
        const KEY = "qr_swipe_hint";         
        const INTERVAL = 24 * 60 * 60 * 1000;    
        const now = Date.now();
        const exp = Number(localStorage.getItem(KEY) || 0);
        if (now > exp) {
            localStorage.setItem(KEY, String(now + INTERVAL));
            setTimeout(() => {
                setShowAnimation(true)
                setTimeout(() => {
                setShowAnimation(false)
                },3000)
            },2000)
        } 
      
    },[dobbleMenu]) 

    useEffect(() => {
        setPageShow([0,1])
        setCurrentZIndex(dobbleMenu.length*2)
        setMaxIndex(dobbleMenu.length)
        if(startPage){
            let testStart= [0,1]
            while(testStart[0] !== startPage[0] && testStart[1] !== startPage[1]) {
                const movePage = document.getElementById(`pageRestau${testStart[1]}`)
                const nextMovePage = document.getElementById(`pageRestau${testStart[1]+1}`)   
                if(movePage) {
                    requestAnimationFrame(() => {
                        movePage.classList.add("flipped")
                        movePage.style.zIndex = currentZindex.toString()
                        setCurrentZIndex(currentZindex+1)
                    })
                }
                setPageShow([testStart[0]+1,testStart[1]+1])
                testStart = [testStart[0]+1,testStart[1]+1]
                if(nextMovePage) {
                    setTimeout(() => {
                        nextMovePage.style.zIndex = currentZindex.toString()
                    }, 100);     
                }
            }
        }
      }, []);
    const [isTurning, setIsTurning] = useState(false);
    const clickRightPage = () => {
        if (isTurning) return; 
        setIsTurning(true);
        const movePage = document.getElementById(`pageRestau${pageShow[1]}`)
        const nextMovePage = document.getElementById(`pageRestau${pageShow[1]+1}`)   
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.add("flipped")
                movePage.style.zIndex = currentZindex.toString()
                setCurrentZIndex(currentZindex+1)
            })
        }
        setPageShow([pageShow[0]+1,pageShow[1]+1])
        if(nextMovePage) {
            setTimeout(() => {
                nextMovePage.style.zIndex = currentZindex.toString()
            }, 300);     
        }
        setTimeout(() => setIsTurning(false), 200);
    }
    const clickLeftPage = () => {
        if (isTurning) return; 
        setIsTurning(true);
        const movePage = document.getElementById(`pageRestau${pageShow[0]}`)    
        if(pageShow[0]-1 === -1) setPageShow([0,1])
        else setPageShow([pageShow[0]-1,pageShow[1]-1])
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.remove("flipped") 
                movePage.style.zIndex = currentZindex.toString()
                setCurrentZIndex(currentZindex+1)   
            })
        }
        setTimeout(() => setIsTurning(false), 200);
    }
    const clickRightPageTel = () => {
        if (isTurning) return; 
        setIsTurning(true);
        let pageToMove = 'pageRestauTel' 
        const movePage = document.getElementById(pageToMove + (pageShow[0] === pageShow[1] ? '0' : '1') +  pageShow[1])
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.add("flipped")
                movePage.style.zIndex = currentZindex.toString()
                setCurrentZIndex(currentZindex+1)
            })
        }
        if(pageShow[0] === pageShow[1]) setPageShow([pageShow[0],pageShow[1]+1])
        else setPageShow([pageShow[1],pageShow[1]])
        setTimeout(() => setIsTurning(false), 300);
    }
    const clickLeftPageTel = () => {
        if (isTurning) return; 
        setIsTurning(true);
        let pageToMove = 'pageRestauTel'
        const movePage = document.getElementById(pageToMove + (pageShow[0] === pageShow[1] ? '1' : '0') +  pageShow[0]) 
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.remove("flipped") 
                movePage.style.zIndex = currentZindex.toString()
                setCurrentZIndex(currentZindex-1)   
            })
        }
        if(pageShow[0]-1 === -1) setPageShow([0,1])
        else {
            setPageShow([pageShow[0]-1,pageShow[1]-1])
            if(pageShow[0] === pageShow[1]) setPageShow([pageShow[0]-1,pageShow[1]])
            else setPageShow([pageShow[0],pageShow[0]])
        } 
        setTimeout(() => setIsTurning(false), 300);
    }

    const touchStartX= useRef(0);
    const touchStartY = useRef(0);
    const isHorizontalSwipe = useRef(false);
    const {  isZoomedRef } = useIsPinchZoomed(isMobile);
    const isSwipeBlocked = useRef(false);
    const pinchDetected = useRef(false);
    const handleTouchStart = useCallback((e: React.TouchEvent<HTMLDivElement>) => {
        pinchDetected.current = false;
        if (e.touches.length > 1) {
            pinchDetected.current = true;
            return;
        }
        isSwipeBlocked.current = !!isMobile && isZoomedRef.current;
        if (isSwipeBlocked.current) {
            return;
        }
        touchStartX.current = e.touches[0].clientX;
        touchStartY.current = e.touches[0].clientY;
        isHorizontalSwipe.current = false;
    }, [isMobile, isZoomedRef]);
    const handleTouchMovePageMenu = useCallback((e: React.TouchEvent<HTMLDivElement>) => {
        if (e.touches.length > 1) {
            pinchDetected.current = true;
            return;
        }
        if (isSwipeBlocked.current || pinchDetected.current) return;
        const deltaX = e.touches[0].clientX - touchStartX.current;
        const deltaY = e.touches[0].clientY - touchStartY.current;

        if (Math.abs(deltaX) > Math.abs(deltaY) * 1.5) {
            isHorizontalSwipe.current = true;
            if (e.cancelable) e.preventDefault();
        }
    },[]);
    const handleTouchEnd = useCallback((e: React.TouchEvent<HTMLDivElement>) => {
        if (isSwipeBlocked.current) {
            isSwipeBlocked.current = false;
            return;
        }
        if (!isHorizontalSwipe.current || e.changedTouches.length > 1 || pinchDetected.current) {
            pinchDetected.current = false;
            return;
        }
        const touchEndX = e.changedTouches[0].clientX;
        const distance = touchEndX - touchStartX.current;
        if (distance < -50) {
            if((pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) < lengthMenuPhone) {
                clickRightPageTel();
            }
        } else if(distance > 50) {
            if(pageShow[0] > 0) clickLeftPageTel()
        }
        
    },[pageShow, lengthMenuPhone, clickRightPageTel, clickLeftPageTel]);

    return (
        <>{fullScreen && <div className="maskFullScreenRestauTel"> <MaskBackground /> </div>}
        <div className={`containerMenuBase secondaryBack ${fullScreen ? 'isFullScreen' : ''}`} >
            
            <div className="mainCorp " >
                {pageShow[0] === 0 ?
                    <div className="borderMenuRestau" style={{marginRight:'1%'}}></div>
                    :
                    <div className="borderMenuRestau lowOpacityHover" style={{marginRight:'1%'}}>
                        <div onClick={clickLeftPage} className="pointer ">
                            <FiChevronLeft size={30}  /> 
                        </div>
                    </div>
                }               
                
                {!isMobile && <div className='menuRestau' style={borderStyleVars}>
                    <div className={`pagesEffectLeft style${styleMenu} ${borderPages && 'transparent' in borderPages ? 'notVisible' : ''}`}></div>
                    <div className={`pagesEffectRight style${styleMenu} ${borderPages && 'transparent' in borderPages ? 'notVisible' : ''}`}></div>
                    {
                     dobbleMenu.map((elem,idMenu) => {
                        return (
                            idMenu === 0 ? 
                                <div className={`pageRestau flipped`} id='page0' key={`pageResto0`} >
                                    <PageMenu key={"pageRestoFF0"+idMenu} pageShow={pageShow[1]} content={emptyMenuPage} index={idMenu} front={true} StyleMenu={styleMenu} isInteract={interactmenu} frontTel={true}/>
                                    <PageMenu key={"pageRestoFB1"+idMenu} pageShow={pageShow[0]} content={elem[1]} index={idMenu} front={false} StyleMenu={styleMenu} isInteract={interactmenu} frontTel={false}/>
                                </div>     
                            : 
                            <div className='pageRestau smallText' key={`pageResto0${idMenu}`} id={`pageRestau${idMenu}`} style={{zIndex: maxIndex - idMenu}}>
                                <PageMenu key={"pageRestoF0"+idMenu} pageShow={pageShow[1]} content={elem[0]} index={idMenu} front={true} StyleMenu={styleMenu} isInteract={interactmenu} frontTel={true}/>
                                <PageMenu key={"pageRestoB1"+idMenu} pageShow={pageShow[0]} content={elem[1]} index={idMenu} front={false} StyleMenu={styleMenu} isInteract={interactmenu} frontTel={false}/>
                            </div> )
                     })
                    }
                    <div className="bottomInfo">
                        <i className="dateUpdate XsmallText">Dernière mise à jour le : {(new Date(dateUpdate || '')).toLocaleDateString()}</i>
                    </div>
                </div> }

               {isMobile && <div className='menuRestauTel' onTouchStart={handleTouchStart}
                    onTouchMove={(e) => handleTouchMovePageMenu(e)}
                    onTouchEnd={handleTouchEnd}>
                    {showAnimation &&
                        <div className="swipeAnimation smallText">
                            <div className="arrows">
                                <svg width={90} height={30} viewBox="0 0 140 50" preserveAspectRatio="none" style={{ display: "block" }}>
                                    <path
                                        d="M 10 35 Q 60 1 130 35"
                                        fill="none"
                                        stroke="white"
                                        strokeWidth={2}
                                        vectorEffect="non-scaling-stroke"
                                    />
                                    <path d="M 10 36 L 15 27" stroke="white" strokeWidth={2} fill="none" vectorEffect="non-scaling-stroke" />
                                    <path d="M 9 35 L 18 38" stroke="white" strokeWidth={2} fill="none" vectorEffect="non-scaling-stroke" />

                                    <path d="M 130 36 L 125 27" stroke="white" strokeWidth={2} fill="none" vectorEffect="non-scaling-stroke" />
                                    <path d="M 129 35 L 122 38" stroke="white" strokeWidth={2} fill="none" vectorEffect="non-scaling-stroke" />
                                </svg>
                            </div>
                            <LiaHandPointerSolid size={45} style={{color:'white'}} className="swipeIcon"/>
                            <span className="firstSpan">Glisser pour</span>
                            <span>tourner les pages</span>
                        </div>
                    }
                    {
                     dobbleMenu.map((elem,idMenu) => {
                        if(pageShow[1] + 1 < idMenu) return null;
                        return ( 
                                <React.Fragment key={`pageRestotel01${idMenu}`}>
                                    
                                    <div className={`pageRestauTel smallText ${idMenu === 0 ? 'flipped' : ''}`}  id={`pageRestauTel0${idMenu}`} style={{zIndex: maxIndex - idMenu}}>
                                        <PageMenu key={"pageRestoB1"+idMenu+Number(fullScreen)}  pageShow={pageShow[0]} content={elem[1]} index={idMenu} front={false} frontTel={false} StyleMenu={styleMenu}  isInteract={interactmenu} isPhone={true}  />
                                        <div className={`iconFullScren ${fullScreen ? 'isFull' : ''}`} onClick={() => {setFullScreen(!fullScreen);if(!fullScreen){nudgeScroll()}}}><div>{fullScreen ? <TfiClose className="icon" size={12}/> : <MdFullscreen className="icon" size={18}/>}</div></div>
                                    </div>
                                    {idMenu !== 0 && 
                                    <div className='pageRestauTel smallText'   id={`pageRestauTel1${idMenu}`} style={{zIndex: maxIndex - idMenu -1}}>
                                        <PageMenu key={"pageRestoF0"+idMenu+Number(fullScreen)} pageShow={pageShow[1]} content={elem[0]} index={idMenu} front={false} frontTel={true} StyleMenu={styleMenu}  isInteract={interactmenu} isPhone={true} />
                                        <div className={`iconFullScren ${fullScreen ? 'isFull' : ''}`} onClick={() => {setFullScreen(!fullScreen);if(!fullScreen){nudgeScroll()}}}><div>{fullScreen ? <TfiClose className="icon" size={12}/> : <MdFullscreen className="icon" size={18}/>}</div></div>
                                    </div> }
                    
                                </React.Fragment>
                            )
                        })
                    }
                    <i className="dateUpdate XsmallText">Dernière mise à jour le : {(new Date(dateUpdate || '')).toLocaleDateString()}</i>
                    <div className="bottomInfo">
                        
                        <div className="numberPagesPhone smallText">
                            <div className={`${(pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) <= 1 ? 'lock' : ''}`} onClick={() => {if(pageShow[0] > 0) {clickLeftPageTel()}}}><FiChevronLeft className="buttonTurn" size={18}/></div>
                            <span>{pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)}/{lengthMenuPhone}</span>
                            <div className={`${(pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) >= lengthMenuPhone ? 'lock' : ''}`} onClick={() => {if((pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) < lengthMenuPhone){clickRightPageTel()}}}><FiChevronRight className="buttonTurn" size={18} /></div>
                        </div>
                    </div>
                </div> }


                <div className="borderMenuRestau pointer lowOpacityHover" style={{marginLeft:'1%'}}> {  pageShow[1] <= dobbleMenu.length-1 - (dobbleMenu[dobbleMenu.length-1][1].elements.length > 0 ? 0 : 1 )&& 
                    <div onClick={clickRightPage }  className="pointer">
                        <FiChevronRight size={30}   /> 
                    </div>
                    } 
                </div>
                {interactmenu && <RightBar isFullScreen={fullScreen} dobbleMenu={dobbleMenu} setFullPlat={setFullPlat}/>}
            </div>   
        </div>
        </>
    )
}

export default MenuRestau


